export enum AmountEntryOption {
  YesWithDefault = 'YesWithDefault',
  YesWithoutDefault = 'YesWithoutDefault',
  YesWithSuggestedAmounts = 'YesWithSuggestedAmounts',
  No = 'No',
}
